import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { productsAPI } from '../services/api';
import ProductCard from '../components/ProductCard';
import '../styles/Home.css';

const Favorites = () => {
  const { t } = useTranslation();
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFavorites();
  }, []);

  const fetchFavorites = async () => {
    try {
      setLoading(true);
      const response = await productsAPI.getFavorites();
      setFavorites(response.data);
    } catch (err) {
      console.error('Erreur:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading-container"><p>{t('common.loading')}</p></div>;
  }

  return (
    <div className="favorites-container">
      <h2>{t('favorites.title')}</h2>

      {favorites.length === 0 ? (
        <div className="no-results">
          <p>{t('favorites.empty')}</p>
          <p className="no-results-hint">
            {t('favorites.emptyHint')}
          </p>
        </div>
      ) : (
        <div className="products-grid">
          {favorites.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Favorites;
